import cn from "classnames";
import { SuccessModal } from '../../SuccessModal'
import React, {
    DetailedHTMLProps,
    forwardRef,
    HTMLAttributes,
    MouseEvent, ReactNode,
    useCallback,
    useEffect,
    useRef,
    useState
} from "react";
import styles from "./Modal.module.scss";
import CloseIcon from "../../DisributorSidebar/close.svg";
import Input from "../../Input/Input";
import DefaultButton from "../../DefaultButton/DefaultButton";
import Link from "next/link";
import { Checkbox } from '../../Checkbox'
import {useForm} from "react-hook-form";
import {IForm} from "../../DisributorSidebar/DistributorSidebar";
import Modal from "../../Modal";
import {axiosForm} from "../../../axios/axiosCustom";
import {API} from "../../../api/api";

interface ModalProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>{
    open: boolean
    setOpen: (open: boolean) => void
    title: string
    formTitle: string
}

const PartnerModal = (({open, setOpen, title, formTitle}: ModalProps) => {
        const [isFormSubmitted, setIsFormSubmitted] = useState(false)
        const {
            register,
            handleSubmit,
            formState: { errors },
        } = useForm({
            mode: 'onChange',
        })
        const onSubmit = async (data) => {
            const dataToSend = {
                "fields":
                    {
                        "TITLE":formTitle,
                        "NAME": data.name,
                        "EMAIL": [{
                            "VALUE" : data.email,
                            "VALUE_TYPE": "WORK"
                        }],
                        "PHONE":[{
                            "VALUE" : data.phone,
                            "VALUE_TYPE": "WORK"
                        }],
                    }
            }
            const fetcher = await axiosForm({
                    url: API.getForm,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify(dataToSend),
                },
            )

            if (fetcher.status === 200) {
            setIsFormSubmitted(true)
            setOpen(false)
          }
        }
        return (
          <>
            <Modal isOpen={open} onRequestClose={() => {return}}>
                <div className={styles.modal}>
                    <CloseIcon onClick={() => setOpen(false)} className={styles.close}/>
                    <h2 className={styles.modalTitle}>{title}</h2>
                    <p className={styles.modalP}>Оставьте ваши контактные данные и наши специалисты оперативно
                        проконсультируют вас по интересующему вопросу</p>
                    <form onSubmit={handleSubmit(onSubmit)} className={styles.inputs}>
                        <Input
                            type="text"
                            name="Имя"
                            fieldName="name"
                            required
                            register={register}
                            errors={errors}
                            errorText="Введите корректное имя"
                            pattern={/^.{1,120}$/}
                            light
                        />
                        <Input
                                mask="+7 (999) 999 99 99"
                                type="text"
                                name="Телефон"
                                fieldName="phone"
                                required
                                register={register}
                                errors={errors}
                                errorText="Введите корректный телефон"
                                pattern={
                                    /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/
                                }
                                light
                            />
                        <Input
                            type="text"
                            name="E-mail"
                            fieldName="email"
                            required
                            register={register}
                            errors={errors}
                            errorText="Введите корректный email"
                            pattern={/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i}
                            light
                        />

                        <DefaultButton  type={'submit'}
                                       onSubmit={e => {
                                           e.preventDefault()
                                           handleSubmit(onSubmit)
                                       }} className={styles.buttonModal}>Отправить
                        </DefaultButton>

                      <div className={`${styles.form_lower}`}>
                        <Checkbox
                          className={''}
                          name="agreement"
                          required
                          register={register}
                          errors={errors}
                          light
                        >
                          Я согласен на обработку моих персональных данных
                        </Checkbox>
                      </div>
                    </form>
                </div>
            </Modal>
            {Object.keys(errors).length === 0 && isFormSubmitted && (
              <SuccessModal
                isFormSubmitted={isFormSubmitted}
                setIsFormSubmitted={setIsFormSubmitted}
              />
            )}
        </>
        )}
);

export default PartnerModal;
